import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BehaviorSubject, Observable } from "rxjs";
import { map } from "rxjs/operators";

import { environment } from "../../environments/environment";
import { User } from "../_models/user";
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";

@Injectable({ providedIn: "root" })
export class AuthenticationService {
  private currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;

  constructor(private http: HttpClient, private router: Router) {
    this.currentUserSubject = new BehaviorSubject<User>(
      JSON.parse(localStorage.getItem("currentUser"))
    );
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  login(email: string, password: string) {
    return this.http
      .post<any>(`${environment.apiUrl}/auth/login`, { email, password })
      .pipe(
        map((user) => {
           console.log(user)
          //   console.log(user.tokens.access.token)

          // login successful if there's a jwt token in the response
          if (user && user.tokens.access.token) {
            if (user.user.role == "user") {
              this.logout();
              this.router.navigateByUrl("/auth/login");
              return false;
            }
            user.user.username = email;
            user.user.password = password;
            user.user._id = user.user.id;
            user.user.permission = [
              "dashboard",
              "users",
              "settings",
              "permissions",
              "streams",
              "degree",
              "branch",
              "specialization",
              "university",
              "country",
              "state",
              "city",
              "approved-by",
              "keywords",
              "onlineexam",
              "programtype",
              "typeofcollege",
              "listings",
              "rounds",
              "genderaccepted",
              "courseduration",
              "castecategory",
              "accreditions",
              "media",
              "amenities",
              "modules",
              "facilities",
              "rankings",
              "ownership",
              "intakesession",
              "deliverymode",
              "tags",
              "course",
              "college-details",
              "student-details",
            ];
            user.user.token = user.tokens.access.token;

            localStorage.setItem("firstname", user.user.firstname);
            localStorage.setItem("lastname", user.user.lastname);
            localStorage.setItem("currentUser", JSON.stringify(user.user));
            localStorage.setItem("userRole", user.user.role);
            localStorage.setItem("userId", user.user.id);
            localStorage.setItem("userPermissions", user.user.permission);
            localStorage.setItem("userEmail", user.user.email);
            localStorage.setItem("adminSess", user.tokens.access.token);
            localStorage.setItem("adminName", user.user.firstname);
            // store user details and jwt token in local storage to keep user logged in between page refreshes

            // localStorage.setItem('firstname', user.user.firstname);
            // localStorage.setItem('lastname', user.user.lastname);
            // localStorage.setItem('refreshtoken', user.tokens.refresh.token);
            // localStorage.setItem('userRole', user.user.role);
            // localStorage.setItem('userId', user.user.id);
            // localStorage.setItem('email', user.user.email);
            //  localStorage.setItem('token', user.tokens.access.token);
            //    console.log(user.user.role)

            this.currentUserSubject.next(user.user);
          }

          return user;
        })
      );
  }

  logout() {
    // remove user from local storage to log user out
    localStorage.removeItem("firstname");
    localStorage.removeItem("lastname");
    localStorage.removeItem("adminName");
    localStorage.removeItem("userRole");
    localStorage.removeItem("userId");
    localStorage.removeItem("email");
    this.currentUserSubject.next(null);
  }
}
